<template>
    <div>
        <div @click="openModal" v-if="this.value !== null" style="cursor:pointer"> <i class="fa fa-eye"></i> </div>
        <main-dialog size="lg" v-model="modalView" :hide-header=true :hide-footer=true >
            <img :src="this.image" width="100%" />
        </main-dialog>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object
        },
        itemField: {
            type: Object
        },
        value: {
            type: String | Number | Object
        }
    },

    data: function() {
        return {
            image: null,
            modalView: false,
        }
    },

    methods: {
        openModal(e) {
            e.stopImmediatePropagation();

            this.image = this.value.localURL,
            this.modalView = true;

        }
    },

    mounted() {
        
    }
}
</script>